<script>
    export default {
      props: ['shellResponse'],
      name: 'shell-sync',
      data () {
        return {}
      },
      computed: {},
      mounted () {
      },
      destroyed () {
      },
      methods: {},
      components: {}
    }
</script>

<template>
  <div class="wrapper">
    <div class="shell-wrap">
      <p class="shell-top-bar">Sistema de Acesso</p>
      <ul class="shell-body" style="min-height: 200px; max-height: 500px;overflow: auto">
        <li class="salert">Iniciando transição para o controle do leilão local. Aguarde, pode demorar até 15 minutos...</li>
        <li class="salert"><i class="fa fa-spin fa-spinner"></i></li>
        <li class="salert" v-for="shellOutput in shellResponse">{{shellOutput}}</li>
      </ul>
    </div>
    <div class="m-t">
      <!--<a class="btn btn-default" @click="criaUsuarioEtapa(1)"><i class="fa fa-user m-r-sm"></i> Criar novo
        usuário</a>
      <a class="btn btn-default" @click="alterarSenhaEtapa(1)"><i class="fa fa-lock m-r-sm"></i> Alterar senha</a>
      <a class="btn btn-danger btn-sm" @click="removeUsuarioEtapa(1)"><i class="fa fa-remove m-r-sm"></i> Remover
        uma conta</a>-->
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ShellSync.vue?14ec3f50